// Types
import type { I_WIDGET_ANALYTICS_EVENTS } from "./widgetAnalyticsEvents.types";

const WIDGET_ANALYTICS_EVENTS: I_WIDGET_ANALYTICS_EVENTS = {
    TI_MODEL: "ti_model",
    PRE_STATE: "pre_state",
    PRE_PRICE: "pre_price",
    IMEI: "imei",
    ADD_PHOTO: "add_photo",
    PHOTO_ASSESSMENT: "photo_assessment",
    ASSESSMENT_RESULT: "assessment_result",
    DISCOUNT_METHOD: "discount_method",
    DISCOUNT_RANGE: "discount_range",
    BIOMETRIC_VERIFICATION: "biometric_verification",
    BIOMETRIC_VERIFICATION_UPLOAD: "biometric_verification_upload",
    BIOMETRIC_VERIFICATION_SUCCESS: "biometric_verification_success",
    PERSONAL_DATA: "personal_data",
    AGREEMENT: "agreement",
    ADD_TO_CART: "add_to_cart",
    CREDIT_CARD: "credit_card",
    CREDIT_CARD_DATA: "credit_card_data",
    CREDIT_CARD_COMPLETE: "credit_card_complete",
    PICKUP_ADDRESS: "pickup_address",
    VOUCHER_SENT: "voucher_sent",
};

export default WIDGET_ANALYTICS_EVENTS;
